export default __webpack_public_path__ + "static/media/logo.0e1ec4d8.png";